import { useEffect, useState } from "react";

export const Seg = ({ value, onChange, opts, id, dark }) => (
  <div className={`flex rounded-lg p-0.5 ${dark ? "bg-white/10" : "bg-slate-100"}`} data-testid={id}>{opts.map(([v, l, I]) => (
    <button key={v} onClick={() => onChange(v)} className={`px-2 py-1 rounded-md text-[11px] font-semibold flex items-center gap-1 transition-colors ${value === v ? (dark ? "bg-white text-slate-900" : "bg-white shadow text-slate-900") : (dark ? "text-slate-300 hover:text-white" : "text-slate-500")}`} data-testid={`${id}-${v}`}>{I && <I className="w-3.5 h-3.5" />}{l}</button>
  ))}</div>
);

export const useAutoDialer = ({ queue, busy, canBrowser, onDial }) => {
  const [run, setRun] = useState(false);
  const [mode, setMode] = useState(() => localStorage.getItem("cc-dial-mode") || "auto");
  const [method, setMethod] = useState(canBrowser ? "browser" : "phone");
  const [left, setLeft] = useState(null);
  const [retry, setRetry] = useState(0);
  const next = queue[0];
  useEffect(() => { localStorage.setItem("cc-dial-mode", mode); if (mode === "manual") setRun(false); }, [mode]);
  useEffect(() => { setMethod(m => (!canBrowser && m === "browser" ? "phone" : canBrowser && m === "phone" && !localStorage.getItem("cc-method") ? "browser" : m)); }, [canBrowser]);
  useEffect(() => { if (!next && !busy) setRun(false); }, [next, busy]);
  useEffect(() => {
    if (!run || busy || !next || mode !== "auto") { setLeft(null); return undefined; }
    setLeft(5);
    const i = setInterval(() => setLeft(s => (s > 1 ? s - 1 : 0)), 1000);
    return () => clearInterval(i);
  }, [run, busy, next?.id, mode, retry]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (left === 0 && run && !busy && next) { setLeft(null); Promise.resolve(onDial(next, method)).then(ok => { if (!ok) setTimeout(() => setRetry(r => r + 1), 1500); }); } }, [left]); // eslint-disable-line react-hooks/exhaustive-deps
  const pickMethod = (m) => { localStorage.setItem("cc-method", m); setMethod(m); };
  return { run, setRun, mode, setMode, method, setMethod: pickMethod, left, next, dialNext: () => next && onDial(next, method) };
};
